const currentYear = () => new Date().getFullYear().toString();
const currentMonth = () => new Date().getMonth() + 1;

export const defaultParams = () => {
    return {
        year: currentYear(),
        monthStart: currentMonth(),
        monthEnd: currentMonth(),
        leadershipIds: [],
        sellerIds: [],
        segmentIds: [],
        brandIds: [],
        groupedBrandIds: [],
        customersIds: [],
        reasonCodes: [],
        reportType: 'advisor',
    };
}

export default {
    summaryData: [],
    detailData: [],
    loading: false,
    detailLoading: false,
    sellers: [],
    customers: [],
    sellersSelect: [],
    leaderships: [],
    groupedBrands: [],
    params: defaultParams(),
    loadedComponent: false,
    lines: [],
    finalLines: [],
};
